import Popover from 'antd/es/popover';
import { PopoverPropsType } from './config';
import React from 'react';

const CustomPopover = ({ children, zIndex = 20000, ...restProps }: PopoverPropsType) => {
  return (
    <Popover zIndex={zIndex} {...restProps}>
      {children}
    </Popover>
  );
};

export default CustomPopover;
